module.exports = __webpack_public_path__ + "static/media/nature_small.638765c0.jpg";